export const cgTypeEnum = {
  CHECKCARD: '1',
  DEBTPAYMENT: '2',
  DEBTPAYMENTENERGY: '3',
};
export const cgMidTypeEnum = {
  saleJet: 'saleJet',
  sale: 'sale',
};
